export const $AcceptedFileTypes = {
	type: 'Enum',
	enum: ['application/pdf','text/csv','text/markdown','application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.ms-powerpoint','application/vnd.openxmlformats-officedocument.presentationml.presentation','application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document',],
} as const;

export const $AgentMessage = {
	properties: {
		content: {
	type: 'string',
	isRequired: true,
},
		role: {
	type: 'string',
	isRequired: true,
},
		tool_calls: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
},
}, {
	type: 'null',
}],
},
		tool_observations: {
	type: 'any-of',
	contains: [{
	type: 'DecisfraToolObservations',
}, {
	type: 'PerplexityToolObservations',
}, {
	type: 'RagToolObservations',
}, {
	type: 'DocumentChunksResult',
}, {
	type: 'ProjectFilesResult',
}, {
	type: 'WayakDataAnalysisResponse',
}, {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		tool_name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		token_usage: {
	type: 'any-of',
	contains: [{
	type: 'TokenUsage',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $AgentTypeEnum = {
	type: 'Enum',
	enum: ['REACT','WAYAK_V1','DATA_ANALYST_V1',],
} as const;

export const $Body_agents_extract_file_content = {
	properties: {
		file: {
	type: 'binary',
	isRequired: true,
	format: 'binary',
},
		schema: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $Body_files_upload_file = {
	properties: {
		file: {
	type: 'binary',
	description: `File to be uploaded.`,
	isRequired: true,
	format: 'binary',
},
	},
} as const;

export const $ChartVisualizationType = {
	type: 'Enum',
	enum: ['graph','metric','table',],
} as const;

export const $ClickhouseConfig = {
	properties: {
		host: {
	type: 'string',
	description: `Host of the clickhouse instance`,
	isRequired: true,
},
		port: {
	type: 'number',
},
		username: {
	type: 'string',
	description: `Username of the clickhouse instance`,
	isRequired: true,
},
		password: {
	type: 'string',
	description: `Password of the clickhouse instance`,
	isRequired: true,
},
	},
} as const;

export const $CreateBrainRequest = {
	properties: {
		creator_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		name: {
	type: 'string',
	isRequired: true,
},
		role: {
	type: 'string',
	isRequired: true,
},
		backstory: {
	type: 'string',
	isRequired: true,
},
		goal: {
	type: 'string',
	isRequired: true,
},
		prebuilt_tools: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'string',
},
}, {
	type: 'null',
}],
},
		org_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $CreateClickHouseDataSourceRequest = {
	properties: {
		id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		created_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		edited_at: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
	isRequired: true,
},
		name: {
	type: 'string',
	description: `Name of the data source`,
	isRequired: true,
},
		type: {
	type: 'SupportedDataSources',
	description: `Type of the data source`,
	isRequired: true,
},
		config: {
	type: 'ClickhouseConfig',
	isRequired: true,
},
		org_id: {
	type: 'string',
	description: `Organization ID of the data source`,
	isRequired: true,
	format: 'uuid',
},
	},
} as const;

export const $CreateDashboardRequest = {
	description: `Request model for creating a new dashboard`,
	properties: {
		name: {
	type: 'string',
	isRequired: true,
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		layout: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
		type: 'LayoutItem',
	},
}, {
	type: 'null',
}],
},
		org_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
	},
} as const;

export const $CreateMessageRequest = {
	properties: {
		thread_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		role: {
	type: 'string',
	isRequired: true,
},
		content: {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
	isRequired: true,
},
		citations: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'string',
},
}, {
	type: 'null',
}],
},
		documents: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		models: {
	type: 'array',
	contains: {
	type: 'string',
},
	isRequired: true,
},
		images: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'string',
},
}, {
	type: 'null',
}],
},
	},
} as const;

export const $CreateMetricRequest = {
	description: `Request model for creating a new metric`,
	properties: {
		datasource_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		org_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		title: {
	type: 'string',
	isRequired: true,
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		chart_config: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		vizualisation: {
	type: 'ChartVisualizationType',
	isRequired: true,
},
		query: {
	type: 'string',
	isRequired: true,
},
		code: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'MetricStatusEnum',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $CreateOrganizationRequest = {
	properties: {
		name: {
	type: 'string',
	isRequired: true,
},
		user_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
	},
} as const;

export const $CreateProjectRequest = {
	properties: {
		user_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		title: {
	type: 'string',
	isRequired: true,
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		org_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $CreateThreadRequest = {
	properties: {
		user_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		title: {
	type: 'string',
	isRequired: true,
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		project_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		model: {
	type: 'string',
	isRequired: true,
},
		org_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $CreateUserContextRequest = {
	properties: {
		user_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		name: {
	type: 'string',
	isRequired: true,
},
		role: {
	type: 'string',
	isRequired: true,
},
		company_description: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $CreateUserRequest = {
	properties: {
		email: {
	type: 'string',
	description: `Email address`,
	isRequired: true,
},
		password: {
	type: 'any-of',
	description: `Password`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		name: {
	type: 'any-of',
	description: `Name`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $CreateUserResponse = {
	properties: {
		user_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
	},
} as const;

export const $DashboardModel = {
	description: `Model representing a row in the 'dashboards' table in the 'ontology' schema`,
	properties: {
		id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		created_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		edited_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		name: {
	type: 'string',
	description: `Name of the dashboard`,
	isRequired: true,
},
		description: {
	type: 'string',
	description: `Description of the dashboard`,
	default: '',
},
		layout: {
	type: 'any-of',
	description: `Layout configuration for dashboard metrics`,
	contains: [{
	type: 'array',
	contains: {
		type: 'LayoutItem',
	},
}, {
	type: 'null',
}],
},
		org_id: {
	type: 'string',
	description: `Organization ID`,
	isRequired: true,
	format: 'uuid',
},
	},
} as const;

export const $DataAnalaystReasoning = {
	properties: {
		explanation: {
	type: 'string',
	isRequired: true,
},
		code: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
	},
} as const;

export const $DataArtifactResult = {
	properties: {
		artifact: {
	type: 'any-of',
	contains: [{
	type: 'DataframeResult',
}, {
	type: 'NumberResult',
}, {
	type: 'TextResult',
}, {
	type: 'PlotResult',
}],
	isRequired: true,
},
		artifact_type: {
	type: 'any-of',
	contains: [{
	type: 'DataArtifactType',
}, {
	type: 'null',
}],
	isRequired: true,
},
	},
} as const;

export const $DataArtifactType = {
	type: 'Enum',
	enum: ['plot','dataframe','number','text',],
} as const;

export const $DataSourceModel = {
	properties: {
		id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		created_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		edited_at: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
	isRequired: true,
},
		name: {
	type: 'string',
	description: `Name of the data source`,
	isRequired: true,
},
		type: {
	type: 'SupportedDataSources',
	description: `Type of the data source`,
	isRequired: true,
},
		config: {
	type: 'any-of',
	description: `Configuration for the data source`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'ClickhouseConfig',
}],
	isRequired: true,
},
		org_id: {
	type: 'string',
	description: `Organization ID of the data source`,
	isRequired: true,
	format: 'uuid',
},
	},
} as const;

export const $DataframeResult = {
	properties: {
		dataframe_url: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		dataframe: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
	},
} as const;

export const $DatasourceChatRequest = {
	description: `Request model for chatting with a datasource agent
Extends the standard MessageRequest with an additional datasource_id field
Can be used with any datasource type (Clickhouse, Postgres, etc.)`,
	properties: {
		messages: {
	type: 'array',
	contains: {
		type: 'Message',
	},
	isRequired: true,
},
		model: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		threadId: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		projectId: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		fileIds: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'string',
},
}, {
	type: 'null',
}],
},
		saveMessages: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
		datasource_id: {
	type: 'string',
	description: `ID of the datasource to use`,
	isRequired: true,
	format: 'uuid',
},
		org_id: {
	type: 'string',
	description: `ID of the organization to use`,
	isRequired: true,
	format: 'uuid',
},
	},
} as const;

export const $DecisfraToolObservations = {
	properties: {
		content: {
	type: 'string',
	isRequired: true,
},
		data: {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
	isRequired: true,
},
	},
} as const;

export const $DocumentChunksResult = {
	properties: {
		document_id: {
	type: 'string',
	isRequired: true,
},
		file_name: {
	type: 'string',
	isRequired: true,
},
		documents: {
	type: 'array',
	contains: {
		type: 'DocumentResult',
	},
	isRequired: true,
},
	},
} as const;

export const $DocumentResult = {
	properties: {
		document_id: {
	type: 'string',
	isRequired: true,
},
		content: {
	type: 'string',
	isRequired: true,
},
		file_name: {
	type: 'string',
	isRequired: true,
},
		page_number: {
	type: 'number',
	isRequired: true,
},
		document_url: {
	type: 'string',
	isRequired: true,
},
		result_number: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ExecuteQueryRequest = {
	properties: {
		sql_query: {
	type: 'string',
	isRequired: true,
},
		datasource_id: {
	type: 'string',
	description: `ID of the datasource to use`,
	isRequired: true,
	format: 'uuid',
},
	},
} as const;

export const $ExecuteQueryResponse = {
	properties: {
		dimensions: {
	type: 'array',
	contains: {
	type: 'string',
},
	isRequired: true,
},
		source: {
	type: 'array',
	contains: {
	type: 'array',
	contains: {
	properties: {
	},
},
},
	isRequired: true,
},
	},
} as const;

export const $FileIndexStatusEnum = {
	type: 'Enum',
	enum: ['NOT_INDEXED','PROCESSING','ERROR','SUCCESS',],
} as const;

export const $FileResult = {
	properties: {
		file_id: {
	type: 'string',
	isRequired: true,
},
		file_name: {
	type: 'string',
	isRequired: true,
},
		file_type: {
	type: 'string',
	isRequired: true,
},
		total_pages: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
	},
} as const;

export const $HTTPValidationError = {
	properties: {
		detail: {
	type: 'array',
	contains: {
		type: 'ValidationError',
	},
},
	},
} as const;

export const $IndexingVersionEnum = {
	type: 'Enum',
	enum: ['UNKNOWN','V1',],
} as const;

export const $LayoutItem = {
	description: `Model representing a single layout item within a dashboard`,
	properties: {
		metricId: {
	type: 'string',
	description: `ID of the metric to display`,
	isRequired: true,
	format: 'uuid',
},
		position: {
	type: 'any-of',
	description: `Position data (x, y, w, h)`,
	contains: [{
	type: 'Position',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Message = {
	properties: {
		id: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		createdAt: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		content: {
	type: 'string',
	isRequired: true,
},
		role: {
	type: 'string',
	isRequired: true,
},
		images: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'string',
},
}, {
	type: 'null',
}],
},
	},
} as const;

export const $MessageProcessingStatusEnum = {
	type: 'Enum',
	enum: ['NOT_STARTED','PROCESSING','ERROR','SUCCESS',],
} as const;

export const $MessageRequest = {
	properties: {
		messages: {
	type: 'array',
	contains: {
		type: 'Message',
	},
	isRequired: true,
},
		model: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		threadId: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		projectId: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		fileIds: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'string',
},
}, {
	type: 'null',
}],
},
		saveMessages: {
	type: 'any-of',
	contains: [{
	type: 'boolean',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $MetricModel = {
	description: `Model representing a row in the 'metrics' table in the 'ontology' schema`,
	properties: {
		id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		created_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		edited_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		status: {
	type: 'MetricStatusEnum',
	description: `Status of the metric`,
	isRequired: true,
},
		datasource_id: {
	type: 'string',
	description: `ID of the datasource this metric uses`,
	isRequired: true,
	format: 'uuid',
},
		org_id: {
	type: 'string',
	description: `Organization ID`,
	isRequired: true,
	format: 'uuid',
},
		title: {
	type: 'string',
	description: `Title of the metric`,
	isRequired: true,
},
		description: {
	type: 'string',
	description: `Description of the metric`,
	default: '',
},
		chart_config: {
	type: 'any-of',
	description: `Configuration for the chart visualization`,
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		vizualisation: {
	type: 'ChartVisualizationType',
	description: `Type of visualization for the metric`,
	isRequired: true,
},
		query: {
	type: 'string',
	description: `SQL query for the metric`,
	isRequired: true,
},
		code: {
	type: 'any-of',
	description: `Additional code for metric processing`,
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $MetricStatusEnum = {
	type: 'Enum',
	enum: ['draft','published','archived',],
} as const;

export const $NumberResult = {
	properties: {
		number: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
	},
} as const;

export const $OrgMembersResponse = {
	properties: {
		org_members: {
	type: 'array',
	contains: {
		type: 'OrgMembershipResponse',
	},
	isRequired: true,
},
	},
} as const;

export const $OrgMembership = {
	properties: {
		id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		created_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		edited_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		org_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		user_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		role: {
	type: 'Role',
	isRequired: true,
},
	},
} as const;

export const $OrgMembershipResponse = {
	properties: {
		id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		created_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		edited_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		org_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		user_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		role: {
	type: 'Role',
	isRequired: true,
},
		profiles: {
	type: 'PersistentUserProfile',
	isRequired: true,
},
	},
} as const;

export const $Organization = {
	properties: {
		id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		created_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		edited_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		name: {
	type: 'string',
	isRequired: true,
},
		image: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $PerplexityToolObservations = {
	properties: {
		content: {
	type: 'string',
	isRequired: true,
},
		citations: {
	type: 'array',
	contains: {
	type: 'string',
},
	isRequired: true,
},
		usage: {
	type: 'any-of',
	contains: [{
	type: 'TokenUsage',
}, {
	type: 'null',
}],
},
		model: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $PersistentBrain = {
	description: `Model representing a row in Supabase 'brains' table`,
	properties: {
		id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		created_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		creator_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		name: {
	type: 'string',
	isRequired: true,
},
		role: {
	type: 'string',
	isRequired: true,
},
		backstory: {
	type: 'string',
	isRequired: true,
},
		goal: {
	type: 'string',
	isRequired: true,
},
		prebuilt_tools: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'string',
},
}, {
	type: 'null',
}],
},
		org_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $PersistentFile = {
	description: `Model representing a row in Supabase 'files' table`,
	properties: {
		id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		created_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		file_name: {
	type: 'string',
	isRequired: true,
},
		file_type: {
	type: 'string',
	isRequired: true,
},
		storage_url: {
	type: 'string',
	isRequired: true,
},
		project_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		file_indexed: {
	type: 'boolean',
	isRequired: true,
},
		index_status: {
	type: 'FileIndexStatusEnum',
	isRequired: true,
},
		total_pages: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		indexed_pages: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
	isRequired: true,
},
		web_url: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		indexing_version: {
	type: 'any-of',
	contains: [{
	type: 'IndexingVersionEnum',
}, {
	type: 'null',
}],
},
		file_summary: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $PersistentMessage = {
	description: `Model representing a row in Supabase 'messages' table`,
	properties: {
		id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		created_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		edited_at: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
	isRequired: true,
},
		thread_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		role: {
	type: 'string',
	isRequired: true,
},
		content: {
	type: 'dictionary',
	contains: {
	properties: {
	},
},
	isRequired: true,
},
		content_text: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		citations: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'string',
},
}, {
	type: 'null',
}],
},
		documents: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		models: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'string',
},
}, {
	type: 'null',
}],
},
		images: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'string',
},
}, {
	type: 'null',
}],
},
		message_processing_status: {
	type: 'any-of',
	contains: [{
	type: 'MessageProcessingStatusEnum',
}, {
	type: 'null',
}],
},
		intermediate_steps: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
		type: 'AgentMessage',
	},
}, {
	type: 'null',
}],
},
		agent_type: {
	type: 'any-of',
	contains: [{
	type: 'AgentTypeEnum',
}, {
	type: 'null',
}],
},
		brain_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		brain_name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		deleted_at: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		usage_synced_at: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		token_usage: {
	type: 'any-of',
	contains: [{
	type: 'TokenUsage',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $PersistentProject = {
	description: `Model representing a row in Supabase 'projects' table`,
	properties: {
		id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		created_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		edited_at: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
	isRequired: true,
},
		user_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		title: {
	type: 'string',
	isRequired: true,
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		org_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		deleted_at: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		usage_synced_at: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $PersistentThread = {
	description: `Model representing a row in Supabase 'threads' table`,
	properties: {
		id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		created_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		edited_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		user_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		title: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		project_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
	isRequired: true,
},
		model: {
	type: 'string',
	isRequired: true,
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		org_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		deleted_at: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
		usage_synced_at: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'date-time',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $PersistentUserContext = {
	description: `Model representing a row in Supabase 'user_context' table`,
	properties: {
		id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
		created_at: {
	type: 'string',
	isRequired: true,
	format: 'date-time',
},
		user_id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		name: {
	type: 'string',
	isRequired: true,
},
		role: {
	type: 'string',
	isRequired: true,
},
		company_description: {
	type: 'string',
	isRequired: true,
},
		org_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $PersistentUserProfile = {
	properties: {
		id: {
	type: 'string',
	isRequired: true,
	format: 'uuid',
},
		name: {
	type: 'string',
	isRequired: true,
},
		email: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $PlotResult = {
	properties: {
		plot_url: {
	type: 'string',
	isRequired: true,
},
		plot_insights: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $Position = {
	description: `Model representing the position and size of a metric in the dashboard layout`,
	properties: {
		x: {
	type: 'number',
	description: `X coordinate (horizontal position)`,
	isRequired: true,
},
		y: {
	type: 'number',
	description: `Y coordinate (vertical position)`,
	isRequired: true,
},
		w: {
	type: 'number',
	description: `Width of the item`,
	isRequired: true,
},
		h: {
	type: 'number',
	description: `Height of the item`,
	isRequired: true,
},
	},
} as const;

export const $ProjectFilesResult = {
	properties: {
		project_id: {
	type: 'string',
	isRequired: true,
},
		files: {
	type: 'array',
	contains: {
		type: 'FileResult',
	},
	isRequired: true,
},
	},
} as const;

export const $ProjectsPaginatedResponse = {
	properties: {
		total_count: {
	type: 'number',
	isRequired: true,
},
		page_size: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		results: {
	type: 'array',
	contains: {
		type: 'PersistentProject',
	},
	isRequired: true,
},
	},
} as const;

export const $RagToolObservations = {
	properties: {
		query: {
	type: 'string',
	isRequired: true,
},
		documents: {
	type: 'array',
	contains: {
		type: 'DocumentResult',
	},
	isRequired: true,
},
		usage: {
	type: 'any-of',
	contains: [{
	type: 'TokenUsage',
}, {
	type: 'null',
}],
},
		embedding_model: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $Role = {
	type: 'Enum',
	enum: ['OWNER','ADMIN','MEMBER',],
} as const;

export const $SupportedDataSources = {
	type: 'Enum',
	enum: ['clickhouse',],
} as const;

export const $TextResult = {
	properties: {
		text: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
	},
} as const;

export const $ThreadsPaginatedResponse = {
	properties: {
		total_count: {
	type: 'number',
	isRequired: true,
},
		page_size: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		results: {
	type: 'array',
	contains: {
		type: 'PersistentThread',
	},
	isRequired: true,
},
	},
} as const;

export const $TokenUsage = {
	properties: {
		input_token_count: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		output_token_count: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		total_token_count: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
		raw_provider_cost: {
	type: 'any-of',
	contains: [{
	type: 'number',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $UpdateBrainRequest = {
	properties: {
		name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		role: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		backstory: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		goal: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		prebuilt_tools: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
	type: 'string',
},
}, {
	type: 'null',
}],
},
		org_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $UpdateClickHouseDataSourceRequest = {
	description: `Request model for updating a Clickhouse datasource`,
	properties: {
		name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		config: {
	type: 'any-of',
	contains: [{
	type: 'ClickhouseConfig',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $UpdateDashboardRequest = {
	description: `Request model for updating an existing dashboard`,
	properties: {
		name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		layout: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
		type: 'LayoutItem',
	},
}, {
	type: 'null',
}],
},
	},
} as const;

export const $UpdateMessageRequest = {
	properties: {
		content: {
	type: 'string',
	description: `Updated message content`,
	isRequired: true,
},
		role: {
	type: 'string',
	description: `Message role`,
	isRequired: true,
},
	},
} as const;

export const $UpdateMetricRequest = {
	description: `Request model for updating an existing metric`,
	properties: {
		title: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		status: {
	type: 'any-of',
	contains: [{
	type: 'MetricStatusEnum',
}, {
	type: 'null',
}],
},
		chart_config: {
	type: 'any-of',
	contains: [{
	type: 'dictionary',
	contains: {
	properties: {
	},
},
}, {
	type: 'null',
}],
},
		vizualisation: {
	type: 'any-of',
	contains: [{
	type: 'ChartVisualizationType',
}, {
	type: 'null',
}],
},
		query: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		code: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		datasource_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $UpdateOrganizationRequest = {
	properties: {
		name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		image: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $UpdateProjectRequest = {
	properties: {
		title: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		org_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $UpdateThreadRequest = {
	properties: {
		title: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		org_id: {
	type: 'any-of',
	contains: [{
	type: 'string',
	format: 'uuid',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $UpdateUserContextRequest = {
	properties: {
		name: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		role: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
		company_description: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;

export const $ValidationError = {
	properties: {
		loc: {
	type: 'array',
	contains: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'number',
}],
},
	isRequired: true,
},
		msg: {
	type: 'string',
	isRequired: true,
},
		type: {
	type: 'string',
	isRequired: true,
},
	},
} as const;

export const $WayakDataAnalysisResponse = {
	properties: {
		reasoning: {
	type: 'any-of',
	contains: [{
	type: 'DataAnalaystReasoning',
}, {
	type: 'null',
}],
	isRequired: true,
},
		artifacts: {
	type: 'any-of',
	contains: [{
	type: 'array',
	contains: {
		type: 'DataArtifactResult',
	},
}, {
	type: 'null',
}],
	isRequired: true,
},
		query: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
	isRequired: true,
},
		usage: {
	type: 'any-of',
	contains: [{
	type: 'TokenUsage',
}, {
	type: 'null',
}],
},
		model: {
	type: 'any-of',
	contains: [{
	type: 'string',
}, {
	type: 'null',
}],
},
	},
} as const;